import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { Checkbox, Input } from '@bedrock/components';
import { useMemoizedFn } from 'ahooks';
import { CheckboxChangeEvent } from '@bedrock/components/lib/Checkbox';
import classNamesBind from 'classnames/bind';
import styles from './index.less';
import classNames from 'classnames';
import { STextArea } from '@mpc/components';

const cx = classNamesBind.bind(styles);

type CheckboxWithTextAreaProps = {
  value?: {
    text: string;
    checked: boolean;
  };
  onChange?: (value: { text: string; checked: boolean }) => void;
  view?: boolean;
  checkboxProps?: React.ComponentProps<typeof Checkbox>;
  textAreaProps?: React.ComponentProps<typeof Input.TextArea>;
  required?: boolean;
  className?: string;
};

const CheckboxWithTextArea = forwardRef(
  (props: CheckboxWithTextAreaProps, ref) => {
    const {
      value = { text: '', checked: false },
      onChange,
      view = false,
      required = false,
      checkboxProps = {},
      textAreaProps = {},
      className = '',
    } = props;

    const validateFields = useMemoizedFn(() => {
      if (required && value.checked && !value.text) {
        return Promise.reject('请输入');
      } else {
        return Promise.resolve(true);
      }
    });

    useImperativeHandle(ref, () => {
      return {
        validateFields,
      };
    });

    return (
      <div className={classNames(cx('checkbox-with-text-area'), className)}>
        <Checkbox
          {...checkboxProps}
          readOnly={view}
          checked={value.checked}
          onChange={(e: CheckboxChangeEvent) => {
            const checked = e?.target?.checked || false;
            onChange?.({
              checked,
              text: checked ? value.text : '',
            } as any);
          }}
          className={`mb-[4px] ${checkboxProps.className}`}
        />
        <STextArea
          {...textAreaProps}
          value={value.text}
          readOnly={view}
          disabled={!value.checked}
          required={required && value.checked}
          placeholder={textAreaProps.placeholder || '请输入'}
          onChange={(e: string | undefined) => {
            onChange?.({
              ...value,
              text: e,
            } as any);
          }}
        />
      </div>
    );
  }
);

export default CheckboxWithTextArea;
